import {
	ArrowButtons,
	Breakpoints,
	ContainerGutter,
	Gallery,
	GallerySlide,
	Lentils,
} from '@volkswagen-onehub/components-core';
import * as React from 'react';
import { Bonus, BonusTypeEnum, CarouselModeEnum } from '@esportal/portal-service';
import { BonusCtr } from './bonus-ctr';
import styled from 'styled-components';
import { BonusLentilsWrapper } from '../../../ui/lentils-wrapper';
import { useIsLandscape } from '../../../../hooks/use-is-landscape';

export interface BonusCarouselProps {
	bonusList: Bonus[];
	carouselMode: CarouselModeEnum;
	showButton?: boolean;
	setBonusPopupData: React.Dispatch<React.SetStateAction<Bonus | undefined>>;
	setIsBonusPopupVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

const GallerySlideContainer = styled(GallerySlide)`
	padding-bottom: var(--size-dynamic0120);
	padding-top: 10px;
	padding-left: 10px;
	padding-right: 10px;
`;

export const BonusCarousel: React.FC<BonusCarouselProps> = ({
	bonusList,
	carouselMode,
	showButton = true,
	setBonusPopupData,
	setIsBonusPopupVisible,
}) => {
	const isLandscape = useIsLandscape();
	const slidesAt960 = isLandscape ? 3 : 2;

	return (
		<Gallery
			data-testid="bonos-gallery-slider"
			id="bonos-gallery"
			bottomElements={
				<>
					<ArrowButtons buttonPreviousAriaLabel="To previous slide" buttonNextAriaLabel="To next slide" />

					<BonusLentilsWrapper $count={bonusList.length} $slidesAt960={slidesAt960}>
						<Lentils />
					</BonusLentilsWrapper>
				</>
			}
			aria-label="MyBonus gallery"
			slidesPerPage={{
				[Breakpoints.default]: 1,
				[Breakpoints.b560]: bonusList.length >= 2 ? 2 : bonusList.length,
				[Breakpoints.b960]: bonusList.length >= slidesAt960 ? slidesAt960 : bonusList.length,
				[Breakpoints.b1280]: bonusList.length >= 3 ? 3 : bonusList.length,
				[Breakpoints.b2560]: bonusList.length >= 4 ? 4 : bonusList.length,
			}}
			fadingEdges="normal"
			gutter={ContainerGutter.dynamic0100}
		>
			{[
				...bonusList.map((bonus, index) => (
					<GallerySlideContainer key={index} aria-labelledby={`slide${index}-heading`} stretch>
						<BonusCtr
							bonus={bonus}
							carouselMode={carouselMode}
							showButton={showButton}
							bonusType={bonus.frame ? BonusTypeEnum.CAR : BonusTypeEnum.PERSON}
							setBonusPopupData={setBonusPopupData}
							setIsBonusPopupVisible={setIsBonusPopupVisible}
						/>
					</GallerySlideContainer>
				)),
			]}
		</Gallery>
	);
};
